import { TasksResponse, TasksOfProjectActionPayload } from '../../types/redux/stores/tasks.types';
import * as actionDefinitions from './actionDefinitions';

export const getTasksOfProjectRequest = (payload: TasksOfProjectActionPayload) => ({
  type: actionDefinitions.GET_TASKS_OF_PROJECT_REQUEST,
  payload,
});
export const getTasksOfProjectRequestFailure = (payload: any) => ({
  type: actionDefinitions.GET_TASKS_OF_PROJECT_REQUEST_FAILURE,
  payload,
});
export const getTasksOfProjectRequestSuccess = (payload: TasksResponse) => ({
  type: actionDefinitions.GET_TASKS_OF_PROJECT_REQUEST_SUCCESS,
  payload,
});
export const getTasksOfProjectStopLoading = (payload: { projectId: string | null }) => ({
  type: actionDefinitions.GET_TASKS_OF_PROJECT_STOP_LOADING,
  payload,
});
